export const environment: Record<string, any> = {
  debug: {
    ngRouter: false,
    effector: false,
  },
  e2eCredentials: {
    password: '',
    adminPassword: '',
    adminUser: '',
  },
  production: true,

  // Runtime values below are populated from assets/config.json
  // by loadRuntimeConfig() before Angular bootstraps.
  baseUrl: '',
  staticAssetsPath: '',
  legacyHttpVersion: '',
  appVersion: '',
  sentryDsn: '',
  collaborationPollingInterval: '',
  scriptExecutionRuntime: '',
  analyticsConfig: {},
  processApiPath: '',
  skipIssuerCheck: '',
  strictDiscoveryDocumentValidation: '',
  keycloak: {
    redirectUri: null,
    responseType: 'code',
    scope: '',
    requireHttps: '',
    showDebugInformation: '',
    disableAtHashCheck: '',
    defaultOrganizationName: '',
  },
  rootDomain: '',
}
